import { render, staticRenderFns } from "./DocumentContentFormalityEditor.vue?vue&type=template&id=355ea41e&scoped=true"
import script from "./DocumentContentFormalityEditor.vue?vue&type=script&lang=js"
export * from "./DocumentContentFormalityEditor.vue?vue&type=script&lang=js"
import style0 from "./DocumentContentFormalityEditor.vue?vue&type=style&index=0&id=355ea41e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355ea41e",
  null
  
)

export default component.exports